import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "card-header border-0 pt-5" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "card-title align-items-start flex-column" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "card-label fw-bolder fs-3 mb-1" }, "Log User")
  ])
], -1)
const _hoisted_3 = { class: "card-body py-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Datatable = _resolveComponent("Datatable")!
  const _component_ModalEdit = _resolveComponent("ModalEdit")!
  const _component_NewCardModal = _resolveComponent("NewCardModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_Datatable, {
          "table-data": _ctx.tableData,
          "table-header": _ctx.tableHeader,
          "enable-items-per-page-dropdown": true,
          key: _ctx.tableKey,
          total: _ctx.total_data,
          "rows-per-page": _ctx.itemsPerPage,
          "current-page": _ctx.currentPage,
          loading: _ctx.is_loading,
          onCurrentChange: _ctx.currentChange,
          onItemsPerPageChange: _ctx.itemsPerPageChange
        }, {
          "cell-username": _withCtx(({ row: user }) => [
            _createTextVNode(_toDisplayString(user.username), 1)
          ]),
          "cell-ip": _withCtx(({ row: user }) => [
            _createTextVNode(_toDisplayString(user.ip), 1)
          ]),
          "cell-user_agent": _withCtx(({ row: user }) => [
            _createTextVNode(_toDisplayString(user.user_agent), 1)
          ]),
          "cell-date": _withCtx(({ row: user }) => [
            _createTextVNode(_toDisplayString(_ctx.formatDate(user.date)), 1)
          ]),
          _: 1
        }, 8, ["table-data", "table-header", "total", "rows-per-page", "current-page", "loading", "onCurrentChange", "onItemsPerPageChange"])
      ])
    ]),
    _createVNode(_component_ModalEdit, { ref: "modalEdit" }, null, 512),
    _createVNode(_component_NewCardModal, { ref: "modalNew" }, null, 512)
  ], 64))
}